import { styled } from 'styled-components';
import { Link } from 'react-router-dom';

export const PeopleLink = styled(Link)`
  color: #4299e1;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
